export default class Footer {


    constructor(el) {
        this.jQueryel = jQuery(el);
        this.init(this.jQueryel);
    }

    init(footer) {
        jQuery(window).bind("load", function() {

            var footerHeight = 0,
                footerTop = 0,
                $footer = footer;

            positionFooter();

            function positionFooter() {

                // footerHeight = $footer.height();
                // footerTop = (jQuery(window).scrollTop() + jQuery(window).height() - footerHeight) + "px";
                // // $footer.css({
                // //     position: 'fixed',
                // //     bottom: 0,
                // //     width: '100%',
                // //     height: footerHeight

                // // });
                // // jQuery('html, body').css({
                // //     'padding-bottom': footerHeight / 2
                // // });
                // console.log('fff', footerTop, (jQuery(document.body).height() + footerHeight),
                //     (jQuery(document.body).height() + footerHeight) > jQuery(window).height()
                // )
                // if ((jQuery(document.body).height() + footerHeight) < jQuery(window).height()) {
                //     $footer.css({
                //         position: "absolute"
                //     }).animate({
                //         top: footerTop
                //     })
                // } else {
                //     $footer.css({
                //         //position: "static"
                //     })
                // }

            }

            jQuery(window)
                .scroll(positionFooter)
                .resize(positionFooter)

        });
    }

}
